import { createTheme } from '@mui/material';
import { TierMap } from 'models';
import { tierPalette } from 'assets/styles/colors';
import colors from './colors';

const theme = createTheme({
  ...colors,
});

const { primary, secondary, success, error, info, warning } = theme.palette;

export const colorMap: Record<string, string> = {
  primary: primary.main,
  secondary: secondary.main,
  success: success.main,
  error: error.main,
  info: info.main,
  warning: warning.main,
};

export type TierColorMap = TierMap<{ background: string; foreground: string }>;

export const tierColorMap: TierColorMap = {
  1: { background: tierPalette.level1, foreground: colors.palette.white },
  2: { background: tierPalette.level2, foreground: colors.palette.white },
  3: { background: tierPalette.level3, foreground: colors.palette.white },
  4: { background: tierPalette.level4, foreground: tierPalette.level2 },
};
